import React from "react";

const WhyJoinUs = () => {
  return (
    <ul>
      <li className="facts-list"> Career Growth Guaranteed </li>
      <li className="facts-list"> Remote First </li>
      <li className="facts-list"> Work-life Balance</li>
      <li className="facts-list"> Regular Social Events</li>
      <li className="facts-list"> Good Compensation </li>
      <li className="facts-list"> Everyone Is Involved In Decision Making</li>
      <li className="facts-list"> Gender And Racial Equality</li>

    </ul>
  );
};
export default WhyJoinUs;
